// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3rjUr","actions":"GroupTable_actions__16ZR3","deleteModalFooter":"GroupTable_deleteModalFooter__1QRAg"};